module.exports = __webpack_public_path__ + "media/docent.df272b60.mp4";